exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selRow[data-v-314b08be]{background-color:#fbff94}.pagination .page-item .page-link[data-v-314b08be]:hover{background-color:#efff6e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-314b08be","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/ListTarafHesabha/ListTarafHesabha.vue
// module id = 577
// module chunks = 0